const greenhouseProvider = {
  id: 'greenhouse',
  name: 'Greenhouse',
  description: 'Connect your Greenhouse ATS to sync jobs and candidates',
  connectionType: 'oauth',
  assessmentSettingsUrl: null,
  assessmentInstructionsUrl: null,
  fields: [],
};

export default greenhouseProvider;
